import { Box, Button, IconButton, Typography } from "@mui/material";
import React from "react";
import BasicSelect from "../components/formControls/Select";
import {
  ArrowRightIcon,
  CalenderTimeIcon,
  PlusIconWhite,
} from "../components/Icons";
import { useNavigate } from "react-router-dom";
import routeConstants from "../utils/routeConstants";

const Conversions = () => {
  const navigate = useNavigate();

  const dateFilterOptions = [
    {
      title: "Last 30 days",
    },
    {
      title: "Last 15 days",
    },
    {
      title: "Last 7 days",
    },
  ];

  const conversionData = [
    {
      title: "Cardiovascular disease",
      link: "https://cardiovascular_disease.stream123.net/registration/go/lkewiow920OPO",
    },
    {
      title: "Diabetes Management",
      link: "https://diabetes_management.stream123.net/registration/go/abcde12345",
    },
    {
      title: "Hypertension Monitoring",
      link: "https://hypertension_monitoring.stream123.net/registration/go/xyz987654",
    },
  ];

  const ConversionCard = ({ title, link }: { title: string; link: string }) => {
    return (
      <Box className="flex w-full justify-center">
        <Box className="w-[90%] flex rounded-xl border py-3 px-4 border-primary-blue-100 justify-between items-center">
          <Box className="flex flex-col gap-[2px]">
            <Typography className="">{title}</Typography>
            <Typography className="!text-xs font-normal text-primary-blue-800 ">
              {link}
            </Typography>
          </Box>
          <Box className="flex gap-1">
            <Typography
              onClick={() => navigate(routeConstants.conversionDetails)}
              className="!text-sm font-normal text-primary-blue-800 underline !cursor-pointer"
            >
              See Details
            </Typography>
            {ArrowRightIcon}
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box className="rounded-[30px] md:mx-[45px] md:mt-8 p-[30px] bg-white flex-column gap-7">
      <Box className="w-full flex gap-3 justify-end">
        <BasicSelect icon={CalenderTimeIcon} options={dateFilterOptions} />
        <Button
          onClick={() => navigate("routeConstants")}
          className="!gap-[5px] !cursor-pointer !rounded-lg !px-[20px] !py-[8px] !bg-primary-blue-950 flex-center !text-white"
        >
          {PlusIconWhite}
          <Typography className="!text-sm !font-normal !text-white  !normal-case">
            Add Form
          </Typography>
        </Button>
      </Box>
      <Box className="flex w-full justify-center flex-col gap-4">
        {conversionData.map((data, index) => (
          <ConversionCard key={index} title={data.title} link={data.link} />
        ))}
      </Box>
    </Box>
  );
};

export default Conversions;
